<!-- Slider Layout (default, for Marketplace) -->
<div class="container-fluid mb-4 recommended" *ngIf="layout === 'slider'">
  <div class="row">
    <div class="col">
      <div class="bbb_main_container">
        <div class="bbb_viewed_title_container d-flex align-items-center justify-content-between">
          <h3 class="bbb_viewed_title">{{title}}</h3>
          <div class="d-none d-lg-block">
            <a [routerLink]="['/products', 'taxonomy', taxonomyId]" class="text-white view-more">
              {{ "common.view_all" | translate }} <i class="fa fa-angle-right"></i>
            </a>
          </div>
          <div class="d-sm-block d-md-block d-lg-none d-none">
            <a [routerLink]="['/products', 'taxonomy', taxonomyId]" class="btn btn-default text-white btn-sm">
              {{ "common.view_all" | translate }} <i class="fa fa-angle-right"></i>
            </a>
          </div>
          <div class="d-lg-none d-sm-none d-block">
            <button class="btn btn-default p-2 text-white btn-sm">
              <i class="fa fa-angle-right"></i>
            </button>
          </div>
        </div>
        <div class="loader-box" style="background-color: #fff;" *ngIf="loadingState; else loadingDiv">
          <div class="lds-dual-ring"></div>
        </div>

        <ng-template #loadingDiv>
          <div class="bbb_viewed_slider_container">
            <div class="row product_row">
              <div *ngFor="let offer of (offers || []).slice(0,18)" class="col-lg-5-of-12 col-md-4 col-6 product_col_gap product_col">
                <div
                  [routerLink]="['/products',offer.product.name.replace(' ', '-'),offer.id]"
                  [attr.title]="offer.product.name"
                  class="bbb_viewed_item discount d-flex flex-column align-items-center justify-content-center text-center">
                  <div class="stock_badge">
                    <div class="badge green" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStock">
                      {{ "product.in_stock" | translate }}
                    </div>
                    <ng-template #outOfStock>
                      <div class="badge red">
                        {{ "product.out_of_stock" | translate }}
                      </div>
                    </ng-template>
                  </div>
                  <div class="bbb_viewed_image">
                    <img
                      [routerLink]="['/products',offer.product.name.replace(' ', '-'),offer.id]"
                      [attr.title]="offer.product.name"
                      [lazyLoad]="getImageSrc(offer)"
                      [defaultImage]="getImageSrc(offer)"
                      [alt]="offer.product.name"
                    />
                  </div>
                  <div class="bbb_viewed_content">
                    <div class="text-start">
                        <a [routerLink]="['/products',offer.product.name.replace(' ', '-'),offer.id]"
                            [attr.title]="offer.product.name"
                            class="bbb_viewed_name prdt_name fs-6 fw-medium">
                            {{
                            currentLanguage == "fr" &&
                            offer.product.productNameFr != null &&
                            offer.product.productNameFr != ""
                                ? offer.product.productNameFr
                                : offer.product.name
                            }}
                        </a>
                    </div>

                    <div class="d-flex align-items-end justify-content-between">
                      <div class="text-start">
                        <div class="bbb_viewed_price text-primary float-start">
                          {{ getOfferPrice(offer) }}
                          {{ offer.currency | uppercase }}
                        </div>
                        <div>
                          <small class="old_price">
                            / &nbsp;{{
                              currentLanguage == "fr" &&
                              offer.measurementunit.descriptionFr != null &&
                              offer.measurementunit.descriptionFr != ""
                                ? offer.measurementunit.descriptionFr
                                : offer.measurementunit.description
                            }}</small>
                        </div>
                      </div>
                      <div class="align-bottom" *ngIf="offer?.pricing?.nicename == 'promotion' && offer?.percentDiscount > 0">
                        <div class="text-primary discount">
                          -{{ offer.percentDiscount }}%
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul class="product-links">
                    <li>
                        <a (click)="addToWishlist(offer, $event)" class="cursor-pointer" data-tip="Add to Wishlist">
                            <i class="fas fa-heart"></i>
                        </a>
                    </li>
                    <li *ngIf="offer.qty > 0 && !offer.availableDate; else noAddToCart">
                        <a (click)="$event.stopPropagation(); addProductToCart(offer)" class="cursor-pointer" data-tip="Add to Cart">
                            <i class="fa fa-shopping-cart"></i>
                        </a>
                    </li>
                    <ng-template #noAddToCart>
                        <li class="d-none"></li>
                    </ng-template>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Grid Layout (for Home page) -->
<div class="best-selling-section" *ngIf="layout === 'grid'">
  <div class="container-fluid">
    <div class="section-header">
      <h2 class="section-title">{{title}}</h2>
      <a [routerLink]="['/products', 'taxonomy', taxonomyId]" class="view-all-link">
        View All <i class="fa fa-angle-right"></i>
      </a>
    </div>

    <div class="categories mb-3">
      <div class="row align-items-center">
        <div class="category-slider mx-auto px-3">
          <ngx-slick-carousel
            class="carousel"
            #slickModal="slick-carousel"
            [config]="slideConfig"
            (init)="slickInit()"
            (breakpoint)="breakpoint()"
            (afterChange)="afterChange()"
            (beforeChange)="beforeChange()"
          >
            <div
              ngxSlickItem
              *ngFor="let offer of offers"
              class="item text-center categ_card"
            >
              <div class="product-card" (click)="navigateToProduct(offer)">
                <div class="card-image-wrapper">
                  <img
                    [lazyLoad]="getImageSrc(offer)"
                    [defaultImage]="defaultImage"
                    [alt]="offer.product.name"
                    class="card-image"
                  />
                  <div class="stock-badge" *ngIf="offer.qty > 0 && !offer.availableDate; else outOfStockGrid">
                    In Stock
                  </div>
                  <ng-template #outOfStockGrid>
                    <div class="stock-badge out-of-stock">
                      Out of Stock
                    </div>
                  </ng-template>
                </div>

                <div class="card-content">
                  <h3 class="product-name">{{ offer.product.name }}</h3>
                  <p class="product-price">
                    {{ getOfferPrice(offer) }} {{ offer.currency | uppercase }} / {{ offer.measurementUnit }}
                  </p>
                  <button [disabled]="!(offer.qty > 0 && !offer.availableDate)" class="add-to-cart-btn" (click)="$event.stopPropagation(); addProductToCart(offer)">
                    <i class="fa fa-shopping-cart"></i>
                  </button>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
</div>
